import {
    AccountSubAccount,
    GetBasicDtoPagination,
    RequestStatusWithData
} from '@customTypes/api/api.types';
import {
    AccountWarehouse,
    BaseWarehouse
} from '@customTypes/general/warehouse.type';

export interface GetAvailableWarehouseDTO extends AccountSubAccount {
    consigneeCountryCode: string;
    consigneePostalCode?: string;
    consigneeCity?: string;
    consigneeProvince?: string;
    parts: {
        clientItemId: string;
        includeSubs?: boolean;
        requiredQty: number;
    }[];
}

export interface GetIOHProductsDTO extends GetBasicDtoPagination {
    readonly consignorSsl: string;
}

export interface WarehouseProduct {
    clientItemId: string;
    availableQty: number;
    requestedQty?: number;
    clientSubstitutes: string[];
    toBeUsedSubstitutesQty?: number;
    validatedWithSubstitutes: boolean;
    description?: string;
}

export interface WarehouseProductWithOriginalQty extends WarehouseProduct {
    availableOriginalQty?: number;
}

export type GetAccountWarehouseDTO = AccountSubAccount;

export type GetAvailableWarehouseTransformedResponse = RequestStatusWithData<{
    items: AccountWarehouse[];
}>;

export type GetWarehouseResponse = RequestStatusWithData<{
    anySslAvailableForAll?: boolean;
    available: BaseWarehouse[];
    unavailable: BaseWarehouse[];
}>;

export type GetWarehouseTransformedResponse = RequestStatusWithData<{
    anySslAvailableForAll?: boolean;
    available: AccountWarehouse[];
    unavailable: AccountWarehouse[];
}>;

export enum REQUEST_PATH {
    AVAILABLE_WAREHOUSE = '/CustomerDelivery/GoodParts/AvailableSslInventory',
    INVENTORY = '/ReturnParts/GoodFromChoice/SslInventory'
}
